const projectComment = {
  path: 'projectComment',
  component: resolve => require(['../../../../pages/user/course/projectcomment'], resolve)
}

export default projectComment



// WEBPACK FOOTER //
// ./src/router/user/course/projectcomment/index.js